import { devLog } from './devLog';
import { isEmpty } from './helpers';

/**
 * @param {string} string
 * @param fallback
 * @returns {object|undefined}
 */
export const safeParse = (string, fallback = null) => {
  if (isEmpty(string)) {
    return fallback;
  }

  let parsed;
  try {
    parsed = JSON.parse(string);
  } catch {
    devLog('warning', 'safeParse', `unable to parse ${string}`, string);
    return string;
  }
  return parsed; // Could be undefined
};

/**
 * @param {string} string
 * @returns {object|undefined}
 */
export const safeParseWithDefault = (string, defaultIfInvalid) => {
  let parsed;
  try {
    parsed = JSON.parse(string);
  } catch {
    devLog('warning', 'safeParse', `unable to parse ${string}`);
    return defaultIfInvalid;
  }
  return parsed; // Could be undefined
};

/**
 * Encode symbols into html encoding
 * @param str
 * @returns {*}
 */
export const encodeHtmlSpecialCharacters = (str) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;', // ' -> &apos; for XML only
    $: '&#36;',
  };

  return str.replace(/[&<>"'$]/g, (m) => {
    return map[m];
  });
};

/**
 * Replace html encoded characters from a text string with their symbols
 * @param str
 * @returns {*}
 */
export const decodeHtmlSpecialCharacters = (str) => {
  const map = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&pound;': '£',
    '&nbsp;': ' ',

    '&#38;': '&',
    '&#60;': '<',
    '&#62;': '>',
    '&#34;': '"',
    '&#39;': "'",
    '&#36;': '$',
    '&#163;': '£',
    '&#160;': ' ',
  };

  const keys = Object.keys(map).join('|');
  const regex = new RegExp(String.raw`(${keys})`, 'g'); // generates pattern ->  /(&amp;|$lt;|&gt;)/g

  // First decode HTML entities, then handle escaped newlines
  return str
    .replace(regex, (m) => {
      return map[m];
    })
    .replace(/\\n/g, '\n');
};
